import { render, staticRenderFns } from "./Tabitha.vue?vue&type=template&id=8b846eac&scoped=true"
import script from "./Tabitha.vue?vue&type=script&lang=js"
export * from "./Tabitha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b846eac",
  null
  
)

export default component.exports